import React from 'react';

import { SearchLinks } from '@whelk/services/src/type/chat';
import { formatTimestamp } from '@whelk/utils/src/time';
import { isNative } from '@whelk/const/src/env';
import { openUrl } from '@whelk/utils';

function SearchIcon({ url }: { url: string }) {
  return (
    <img
      src={url}
      onError={(e) => {
        if (e && e.target) {
          (e.target as HTMLImageElement).src = '/assets/img/search-default-new.png';
        }
      }}
      alt=''
      className='mr-1 h-3 w-3'
    />
  );
}

export interface SearchListProps {
  list: SearchLinks[];
}

export function SearchList({ list }: SearchListProps) {
  const open = (href: string) => {
    if (isNative) {
      openUrl(href);
    } else {
      openUrl(href, false, '_blank');
    }
  };

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, url: string) => {
    e.preventDefault();
    open(url);
  };

  return (
    <div className='h-full overflow-y-scroll py-2 pl-4 pr-3 md:pl-2 md:pr-1'>
      {list.map(({ domainName, title, url, webIcon, detail, publishTs }) => {
        const timestamp = formatTimestamp(publishTs);
        return (
          <a
            href={url}
            target='_blank'
            key={title}
            onClick={(e) => handleClick(e, url)}
            className='md:hover:bg-col_text05 md:hover:text-col_a bg-col_bg15 text-col_text00 font-500 md:font-400 md:text-col_a visited:text-col_a_visited mb-[8px] flex flex-col gap-[6px] rounded-[16px] p-3 md:rounded-[12px]'
            rel='noreferrer'
          >
            <p className='text-[15px]'>{title}</p>
            <p className='text-col_fill04 text-[13px]'>{detail}</p>
            <div className='text-col_text02 flex items-center text-[12px]'>
              <SearchIcon url={webIcon} />
              <p>
                {domainName}
                {timestamp && (
                  <>
                    <span className='mx-1'>·</span>
                    {timestamp}
                  </>
                )}
              </p>
            </div>
          </a>
        );
      })}
    </div>
  );
}
